export default {
  inheritAttrs: false,
  props: {
    isSlide: {
      type: Boolean
    },
    time: {
      default: 500
    },
    minHeight: {
      type: null,
      default: '0px'
    }
  },
  data: function data() {
    return {
      targetHeight: null
    };
  },
  watch: {
    isSlide: function isSlide(val) {
      if (val == true) {
        // this.funTransitionHeight(this.$refs.slider, this.time);
        this.funTransitionHeight(this.time);
      } else {
        this.$refs.slider.style.height = this.minHeight || '';
      }
    }
  },
  mounted: function mounted() {
    if (this.isSlide) {
      this.funTransitionHeight(this.time);
    }
  },
  methods: {
    funTransitionHeight: function funTransitionHeight(time) {
      var _this = this;
      var element = this.$refs.slider;
      // copy from Zhang Xinxu
      if (typeof window.getComputedStyle == "undefined") {
        element.style.height = 'auto';
        return;
      }
      if (!this.targetHeight) {
        var height = window.getComputedStyle(element).height;
        element.style.transition = 'none'; // 本行2015-05-20新增，mac Safari下，貌似auto也会触发transition, 故要none下~

        element.style.height = 'auto';
        this.targetHeight = window.getComputedStyle(element).height;
        element.style.height = height;
        if (time) element.style.transition = 'height ' + time + 'ms';
      }
      setTimeout(function () {
        element.style.height = _this.targetHeight;
      }, 0);
    }
  }
};